import React, { useEffect } from 'react';
import { LoadingStates } from "@pb/utils/request";
import { Form } from "../../../Form";
import Modal from "../../../../ui/Modal";
import StatusMessage from "../../../../ui/StatusMessage";
import BodyText from "../../../../ui/Typography/texts/BodyText";
import GiftCardForm from './GiftCardForm';
import styles from './GiftCardModal.module.scss';
const GiftCardModal = ({ labels, isModalOpen, toggleModal, addGiftCard, giftCardError, addGiftCardStatus, }) => {
    useEffect(() => {
        if (addGiftCardStatus === LoadingStates.LoadedSuccess) {
            toggleModal(false);
        }
    }, [addGiftCardStatus]);
    const handleSubmit = (formData) => {
        addGiftCard(formData);
    };
    return (React.createElement(Modal, { closeButtonText: labels.close, isOpen: isModalOpen, toggleModal: toggleModal, title: labels.heading, textAlign: "left", isModalCompressed: true, modalTitleClassName: styles.giftCardHeading, className: styles.giftCardModal },
        React.createElement(BodyText, { className: styles.giftCardText }, labels.description),
        addGiftCardStatus === LoadingStates.LoadedFail && (React.createElement(StatusMessage, { iconPosition: "start", type: (giftCardError === null || giftCardError === void 0 ? void 0 : giftCardError.isWarningMessage) ? 'warning' : 'invalid', icon: (giftCardError === null || giftCardError === void 0 ? void 0 : giftCardError.isWarningMessage) ? 'warning' : 'error', message: labels.errorMessage, className: styles.statusMessage })),
        React.createElement(Form, { className: styles.giftCardForm, currentData: { cardNumber: '', cardPin: '' }, onSubmit: handleSubmit, mode: "onChange" },
            React.createElement(GiftCardForm, { labels: labels, disabled: !!(giftCardError === null || giftCardError === void 0 ? void 0 : giftCardError.isMaxError) }))));
};
export default GiftCardModal;
//# sourceMappingURL=GiftCardModal.js.map